<template>
  <CompanyWrapper :isOpenEvent="isOpenEvent">
    <div class="main">
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list" v-if="!isOpenEvent">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/company/summary` }"
            class="breadcrumb-trail__list--item__link"
          >
            EventList
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/company/event/${this.$route.query.event}` }"
            class="breadcrumb-trail__list--item__link"
          >
            Detail
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/company/ranking`,
              query: {
                event: this.$route.query.event,
                page: this.$route.query.page,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            Result
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{
              path: `/company/ranking/certificate`,
              query: {
                event: this.$route.query.event,
                team: this.$route.query.team,
              },
            }"
            class="breadcrumb-trail__list--item__link"
          >
            Certificate
          </router-link>
        </li>
      </ol>
      <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
      <InternalServerError
        v-if="isCreateServerError"
        :lang="lang"
      ></InternalServerError>
      <main v-if="!isLoading && !isBadRequest && !isCreateServerError">
        <figure class="draw-loading flex-all-center" v-if="!isDrawingData">
          <img src="../../../../assets/images/loading.gif" alt="loading" />
        </figure>
        <!-- 変換後の保存用画像 -->
        <figure class="download-img" v-if="imageDataUrl">
          <img :src="imageDataUrl" alt="" width="100%" />
        </figure>
        <div class="download-sentence" v-if="isDrawingData">
          <small>
            {{ Certificate.save[lang] }}
          </small>
        </div>
        <!-- 保存用（画面には表示しない(位置 : -9999px)） -->
        <CertificateWidth1000
          id="js-download"
          class="width1000"
          :dataRunner="dataRunner"
          :is-company="true"
        ></CertificateWidth1000>
      </main>
    </div>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/sp/company/CompanyWrapper";
import BadRequest from "../../../../components/common/status/BadRequest";
import InternalServerError from "../../../../components/common/status/InternalServerError";
import CertificateWidth1000 from "../../../../components/common/CertificateWidth1000";
import certificate from "../../../../assets/constants/ranking/certificate/certificate.json";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import html2canvas from "html2canvas";
import cognito from "../../../../plugins/cognito";

export default {
  data() {
    return {
      isLoading: true,
      isBadRequest: false,
      isCreateServerError: false,
      isDrawingData: false,
      isOpenEvent: false,
      dataRunner: null,
      imageDataUrl: "",
    };
  },
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    const nassId = this.$route.query.event;
    const params = {
      code: nassId,
      lang: this.lang,
      is_company_event: true,
      company_user_name: cognito.getUserName() || "",
    };
    const response = await EventRepository.getEvent(params);
    this.isOpenEvent = response.data.text.open_event_flag;
  },
  async mounted() {
    // 既存のcanvasタグがある場合は削除
    if (document.querySelector("#canvas-tag")) {
      document.querySelector("#canvas-tag").remove();
    }
    const isCompany = this.$route.path.includes("company");
    const RankingRepository = RepositoryFactory.get("ranking");
    try {
      let response;
      if (this.$route.query.runner) {
        response = await RankingRepository.getRunner({
          event: this.$route.query.event,
          runner: this.$route.query.runner,
          lang: this.lang,
          is_company_event: isCompany || "",
          company_user_name: cognito.getUserName() || "",
        });
      } else {
        response = await RankingRepository.getTeamRunner({
          event: this.$route.query.event,
          company: this.$route.query.team,
          lang: this.lang,
          is_company_event: isCompany || "",
          company_user_name: cognito.getUserName() || "",
        });
      }
      this.dataRunner = response.data;
      this.isLoading = false;
      this.$nextTick(function () {
        html2canvas(document.getElementById("js-download")).then((canvas) => {
          const tag = document.body.appendChild(canvas);
          tag.id = "canvas-tag";
          tag.classList.add("none");
          this.imageDataUrl = document.getElementById("canvas-tag").toDataURL();
          this.isDrawingData = true;
        });
      });
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        return;
      }
      this.isCreateServerError = true;
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    Certificate: function () {
      return certificate;
    },
    lang: function () {
      return this.$store.state.lang;
    },
  },
  components: {
    CompanyWrapper,
    BadRequest,
    InternalServerError,
    CertificateWidth1000,
  },
  name: "Certificate",
};
</script>

<style scoped>
.main {
  padding: 0 15px;
  position: relative;
  .draw-loading {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }
  .download-img {
    margin: 60px 0 0 0;
  }
  .download-sentence {
    margin: 32px 0 0 0;
    text-align: center;
  }
  .width1000 {
    top: -9999px;
    left: -9999px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/company/certificate/Certificate.vue